import dayjs from 'dayjs'

export function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate()
}

export function getFirstDayOfMonth(year, month) {
  return new Date(year, month, 1).getDay()
}

export function formatDatesForModal(localAvailableDates) {
  if (!localAvailableDates || !Array.isArray(localAvailableDates)) return []

  const datesByDay = {}

  localAvailableDates.forEach((dateEntry) => {
    let date,
      start,
      end,
      eventId,
      assignedUser,
      isBooked = false

    if (dateEntry && typeof dateEntry === 'object' && dateEntry.start) {
      date = dayjs(dateEntry.start).toDate()
      start = dayjs(dateEntry.start).format('LT')
      end = dayjs(dateEntry.end).format('LT')
      eventId = dateEntry.eventId
      assignedUser = dateEntry.assignedUser
      isBooked = dateEntry.isBooked || false
    } else {
      date = dayjs(dateEntry).toDate()
      start = dayjs(dateEntry).format('LT')
      end = dayjs(dateEntry).add(30, 'minute').format('LT')
    }

    const dateString = dayjs(date).format('YYYY-MM-DD')
    const isPassed = dayjs(date).isBefore(dayjs())

    if (!datesByDay[dateString]) {
      datesByDay[dateString] = { date, isAvailable: true, slots: [] }
    }

    datesByDay[dateString].slots.push({
      id:
        dateEntry && typeof dateEntry === 'object'
          ? `${dateEntry.start}-${dateEntry.end}`
          : dateEntry,
      startTime: start,
      endTime: end,
      isAvailable: !isPassed && !isBooked,
      originalData: dateEntry,
      eventId,
      assignedUser,
    })
  })

  return Object.values(datesByDay)
}
